import { MetadataEntityBase } from '../../abstract-metadata-entity-base';
import { IBizEventEntity } from '../interface-biz-event-entity';

/**
 * ä¸å¡äºä»¶å®ä½ç±»
 */
export class AifBizEventEntity extends MetadataEntityBase implements IBizEventEntity {
    BeMetadataId: string;

    BeType: string;

    BeEventRouterMetadataId: string;

    BeEventRouterComponentId: string;

    BizEventAgentMetadataId: string;

    BizEventAgentComponentId: string;

    VoMetadataId: string;

    VoType: string;

    BeId: string;

    VoId: string;

}